import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/Components/ui/toggle-group';
import { Badge } from '@/Components/ui/badge';
import { Stack } from '@/Components/ui/layout';
import { Text } from '@/Components/ui/typography';
import { cn } from '@/lib/utils';

export const BillingCycleToggle = ({ value, onValueChange }) => {
  const cycles = [
    { value: 'monthly', label: 'Monthly', savings: null },
    { value: 'quarterly', label: 'Quarterly', savings: '10%' },
    { value: 'annual', label: 'Annual', savings: '20%' },
  ];

  return (
    <Stack spacing="sm" className="items-center">
      <ToggleGroup
        type="single"
        value={value || 'monthly'}
        onValueChange={(newValue) => {
          if (newValue) onValueChange(newValue);
        }}
        className="inline-flex items-center justify-center rounded-lg bg-muted p-1 gap-2"
      >
        {cycles.map((cycle) => (
          <ToggleGroupItem
            key={cycle.value}
            value={cycle.value}
            className={cn(
              "relative px-4 py-2 text-sm font-medium transition-all overflow-visible",
              "data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm",
              "data-[state=off]:text-muted-foreground"
            )}
          >
            <span className="capitalize whitespace-nowrap">{cycle.label}</span>
            {cycle.savings && (
              <Badge 
                variant="secondary" 
                className="absolute -top-2 -right-2 h-5 px-1.5 text-[10px] font-semibold leading-none rounded-full bg-primary text-primary-foreground z-10"
              >
                {cycle.savings} OFF
              </Badge>
            )}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <Text size="sm" className="text-muted-foreground text-center">
        Choose your billing cycle to see updated pricing
      </Text>
    </Stack>
  );
};
